// src/hooks/useClientNavigation.mjs
import { useNavigate, useParams } from 'react-router-dom';

export const useClientNavigation = () => {
    const navigate = useNavigate();
    const { clientName } = useParams();
    
    const navigateToClient = (path) => {
        // Remove barra inicial se existir para evitar dupla barra
        const cleanPath = path.startsWith('/') ? path.slice(1) : path;
        navigate(`/${clientName}/${cleanPath}`);
    };
    
    const navigateToClientRoot = () => {
        navigate(`/${clientName}`);
    };
    
    const navigateBack = () => {
        navigate(-1);
    };
    
    return { 
        navigateToClient, 
        navigateToClientRoot, 
        navigateBack,
        clientName 
    };
};
